import { render, staticRenderFns } from "./MenusDy.vue?vue&type=template&id=d1201854&scoped=true&"
import script from "./MenusDy.vue?vue&type=script&lang=js&"
export * from "./MenusDy.vue?vue&type=script&lang=js&"
import style0 from "./MenusDy.vue?vue&type=style&index=0&id=d1201854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1201854",
  null
  
)

export default component.exports